import(/* webpackMode: "eager", webpackExports: ["PreviewBar"] */ "/vercel/path0/modules/foundation/components/preview-bar/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/vercel/path0/modules/foundation/components/providers/app-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/foundation/components/providers/preview-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopNav"] */ "/vercel/path0/modules/site/components/DesktopNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNav"] */ "/vercel/path0/modules/site/components/MobileNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/site/sanity/footer/FooterContainerDraft.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/site/sanity/navbar/NavbarContainerDraft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/(frontend)/layout.tsx\",\"import\":\"\",\"arguments\":[{\"variable\":\"--font-saira\",\"display\":\"swap\",\"src\":[{\"path\":\"../../public/fonts/Saira-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Saira-Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Saira-Semibold.woff2\",\"weight\":\"600\",\"style\":\"normal\"}]}],\"variableName\":\"saira\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/logo-light.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/miljofyrtarn.png");
